import { thousandSeparator } from '../../../utils/numberHelpers';
import { useDispatch, useSelector } from '../../../store/store';
import { PaymentMethod, Transaction } from '../../../store/workspace/types';
import { SubscriptionPlans } from '../../../configs/payment';
import MotionWrapper from '../../../layouts/MotionWrapper';
import PlanSkeleton from './components/PlanSkeleton';
import Spinner from '../../../components/Spinner';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import Card from './components/Card';
import {
    PlusIcon,
    CheckSolidIcon,
    TimesSolidIcon,
    InformationIcon,
} from '../../../assets/icons';
import {
    getProfileDataThunk,
    getPaymentMethodsThunk,
    getSubsciptionHistoryThunk,
} from '../../../store/workspace/thunks';
import {
    setPlansModalShow,
    setAddNewCardModal,
    setPaymentRetryMode,
    setSelectedTransaction,
    setChooseCreditCardModal,
    setTransactionDetailModal,
    setConfirmCancelSubscriptionModal,
} from '../../../store/workspace/slice';
import {
    selectProfile,
    selectPaymentMethods,
    selectSubscriptionHistory,
    selectTransactionsHistory,
    selectFetchingpPaymentMethods,
    selectFetchingSubscriptionHistory,
} from '../../../store/workspace/selectors';
import { setNotification } from '../../../store/general/slice';

export default function Payment() {
    const navigate = useNavigate();
    // const paymentMethods = useSelector(selectPaymentMethods);
    const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
    // const fetching = useSelector(selectFetchingpPaymentMethods);
    const [fetching, setFetching] = useState(false);
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [tab, setTab] = useState<'Cards' | 'History'>('Cards');
    const transactionsHistory = useSelector(selectTransactionsHistory);
    const subscriptionHistory = useSelector(selectSubscriptionHistory);
    const fetchingSubscriptionHistory = useSelector(selectFetchingSubscriptionHistory);

    useEffect(() => {
        if (profile?.userRole === 'member') {
            navigate('/workspace');
        }
    }, [profile]);

    useEffect(() => {
        dispatch(getProfileDataThunk());

        setFetching(true);
        dispatch(getPaymentMethodsThunk({
            action: 'get_payment_methods',
        }))
            .unwrap()
            .then(r => {
                setPaymentMethods(r);
            })
            .catch(e => {
                dispatch(setNotification(['Something went wrong,Please try again...', 'error']));
            })
            .finally(() => {
                setFetching(false);
            })

        dispatch(getSubsciptionHistoryThunk({
            action: 'get_subscription_status',
        }));
    }, []);

    const viewTransactionDetail = (item: Transaction) => {
        dispatch(setSelectedTransaction(item));
        dispatch(setTransactionDetailModal(true));
    };

    const retryPayment = () => {
        dispatch(setPaymentRetryMode(true));
        dispatch(setChooseCreditCardModal(true));
    };

    return (
        <MotionWrapper className={styles.container}>
            {fetchingSubscriptionHistory && <PlanSkeleton />}
            {!fetchingSubscriptionHistory && subscriptionHistory && <div className={styles.plan}>
                <span className={styles.plan_title}>Plan Information</span>
                <div className={styles.plan_header} data-has-error={subscriptionHistory?.status !== 'active'}>
                    <span className={styles.plan_header_name}>
                        {/* {subscriptionHistory ? `${plansEnum[subscriptionHistory.plan_name]} plan` : ''} */}
                        {subscriptionHistory ? SubscriptionPlans[subscriptionHistory.plan_name] : ''}
                    </span>
                    <div className={styles.plan_header_status}>
                        <span>{subscriptionHistory?.status}</span>
                        {subscriptionHistory?.status === 'active' ? <CheckSolidIcon /> : <TimesSolidIcon />}
                    </div>
                </div>
                {/* <div className={styles.plan_detail_message}>
                        <TimesCircleIcon />
                        <p>
                            Unfortunately, your payment could not be processed. Please
                            check your payment details and try again, or use an alternative
                            payment method. For further assistance, contact our support team.
                        </p>
                    </div> */}

                <div className={styles.plan_actions}>
                    {(
                        subscriptionHistory?.status === 'past_due' ||
                        subscriptionHistory?.status === 'unpaid' ||
                        subscriptionHistory?.status === 'incomplete'
                    ) ? <Button
                        type='Primary'
                        text='Pay now'
                        className={styles.plan_actions_btn}
                        onClick={retryPayment}
                    /> :
                        <Button
                            type='Primary'
                            text='Upgrade plan'
                            className={styles.plan_actions_btn}
                            onClick={() => dispatch(setPlansModalShow(true))}
                        />}
                    {(
                        (subscriptionHistory?.status === 'active' ||
                            subscriptionHistory?.status === 'incomplete' ||
                            subscriptionHistory?.status === 'past_due' ||
                            subscriptionHistory?.status === 'unpaid' ||
                            subscriptionHistory?.status === 'trialing')
                    ) && <Button
                            type='Error'
                            text='Cancel'
                            className={styles.plan_actions_btn}
                            onClick={() => dispatch(setConfirmCancelSubscriptionModal(true))}
                        />}
                </div>
            </div>}
            {/* profile?.planType !== 'free_trial' && */}
            <div className={styles.cards_and_history}>
                <div className={styles.tab}>
                    <div
                        className={styles.tab_item}
                        data-is-active={tab === 'Cards'}
                        onClick={() => setTab('Cards')}
                    >
                        <span>Your cards</span>
                    </div>
                    <div
                        className={styles.tab_item}
                        data-is-active={tab === 'History'}
                        onClick={() => setTab('History')}
                    >
                        <span>Billing History</span>
                    </div>
                </div>
                {tab === 'Cards' && <div className={styles.cards_list}>
                    {!fetching && paymentMethods && paymentMethods.length === 0 &&
                        <span className={styles.cards_list_empty}>
                            You didn’t add any cards.
                        </span>}
                    {!fetching && paymentMethods?.map(method => <Card paymentMethod={method} />)}
                    {fetching && <Spinner />}
                    <div
                        className={styles.cards_list_add_new_card}
                        onClick={() => dispatch(setAddNewCardModal(true))}
                    >
                        <PlusIcon />
                        <span>Add new credit or debit card</span>
                    </div>
                </div>}
                {tab === 'History' && <div className={styles.history}>
                    <span className={styles.history_description}>Showing invoices within the past 12 months.</span>
                    <div className={styles.history_table}>
                        {subscriptionHistory && subscriptionHistory.payments?.length > 0 ? <table>
                            <thead>
                                <tr>
                                    <th>Invoice</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                    <th>Created date</th>
                                    <th>Billing details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {subscriptionHistory.payments.map(item => <tr>
                                    <td>{item.invoice_id}</td>
                                    <td>
                                        <span
                                            className={styles.status}
                                            data-status={item.status}
                                        >
                                            {item.status}
                                        </span>
                                    </td>
                                    <td>{thousandSeparator(item.amount_paid / 100)}$</td>
                                    <td>{new Date(item.created * 1000)?.toDateString()}</td>
                                    <td>
                                        <span
                                            className={styles.link}
                                            onClick={() => viewTransactionDetail(item)}
                                        >
                                            Billing Details
                                        </span>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table> : <div className={styles.history_table_empty}>
                            <InformationIcon />
                            <span>No data.</span>
                        </div>}
                    </div>
                </div>}
            </div>
        </MotionWrapper>
    )
};
